import { MonitorSmallIcon } from './MonitorSmallIcon';

/**
 * author: Michael Irigoyen
 * id CE677999-FD3D-4120-A755-2EF579A82528
 * name monitor-small
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/monitor-small.svg
 * tags
 * - Device / Tech 
 */
export const MonitorCrtIcon = MonitorSmallIcon;
export default MonitorCrtIcon